import { render, staticRenderFns } from "./heart-icon.vue?vue&type=template&id=3563556b"
import script from "./heart-icon.vue?vue&type=script&lang=js"
export * from "./heart-icon.vue?vue&type=script&lang=js"
import style0 from "./heart-icon.vue?vue&type=style&index=0&id=3563556b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports